import ExcludeFromLookup from '../../../../../enums/ExcludeFromLookup';
import {onlyDeliveryAddresses} from '../addressFormType';
import * as max from '../max-length-validators';
import * as required from '../required-validators';
import isAddresseeInvalid from './isAddresseeInvalid';

export default {
  name: 'addressee',
  label: 'checkout.delivery.address.field.label.name.text',
  filterCondition: onlyDeliveryAddresses,
  required: true,
  maxLength: 35,
  validate: [required.fullName, max.lengthAddressee(35), isAddresseeInvalid],
  excludeFromAddressLookup: ExcludeFromLookup.BEFORE,
};
